export default __webpack_public_path__ + "static/media/fruit22.9e9081d1.jpg";